import React from 'react';
import { Route } from 'react-router-dom';
import { graphql, compose } from 'react-apollo';

import RoleList from 'Components/Presentation/Roles/RoleList';
import RoleEditContainer from './Edit';

import AllRolesQuery from 'GraphQueries/Roles/AllQuery';
import NewRoleMutation from 'GraphQueries/Roles/NewMutation';
import NewRoleSubscription from 'GraphQueries/Roles/NewSubscription';
import DeleteRoleMutation from 'GraphQueries/Roles/DeleteMutation';
import RoleDeleteSubscription from 'GraphQueries/Roles/DeleteSubscription';

class RoleIndexContainer extends React.Component {

    static defaultProps = {
        roles: [],
        loading: false
    }

    state = {
        role: null
    }

    componentDidMount() {
        this.props.subscribeToChanges();
    }

    saveRole = async (role) => {
        await this.props.onAdd(role);
        this.navigateWithData(`/system/roles/${role.id}/manage/settings`, role);
    }

    deleteRole = async (role) => {
        await this.props.onDelete(role);
    }

    navigateWithData = (uri, role) => {
        const { history } = this.props;
        this.setState({ role });
        history.push(uri);
    }

    render() {
        const { roles, loading } = this.props;
        const { role } = this.state;
        return (
            <React.Fragment>
                <Route path="/system/roles" exact render={props => {
                    return (
                        <RoleList {...props} loading={loading} onEdit={this.navigateWithData} roles={roles}
                            onRoleAdded={this.saveRole} onRoleRemoved={this.deleteRole} />
                    )}
                } />
                <Route path="/system/roles/list" render={props => {
                    return (
                        <RoleList {...props} loading={loading} onEdit={this.navigateWithData} roles={roles}
                            onRoleAdded={this.saveRole} onRoleRemoved={this.deleteRole} />
                    )}
                } />
                <Route path="/system/roles/:id/manage" render={props => {
                    return (
                        <RoleEditContainer role={role}  {...props} />
                    )}
                } />
            </React.Fragment>
        );
    }
}

export default compose(
    graphql(AllRolesQuery, {
        options: { fetchPolicy: 'network-only' },
        props: (props) => ({
            roles: props.data.listRoles && props.data.listRoles.items,
            loading: props.data.loading,
            subscribeToChanges: params => {
                props.data.subscribeToMore({
                    document: NewRoleSubscription,
                    updateQuery: (prev, { subscriptionData: { data: { onCreateRole } } }) => ({
                        ...prev,
                        listRoles: { items: [onCreateRole, ...prev.listRoles.items.filter(item => item.id !== onCreateRole.id)], __typename: 'Role' }
                    })
                });
                props.data.subscribeToMore({
                    document: RoleDeleteSubscription,
                    updateQuery: (prev, { subscriptionData: { data: { onDeleteRole } } }) => ({
                        ...prev,
                        listRoles: { items: [...prev.listRoles.items.filter(item => item.id !== onDeleteRole.id)], __typename: 'Role' }
                    })
                });
            }
        }),
    }),
    graphql(DeleteRoleMutation, {
        props: (props) => ({
            onDelete: (role) => props.mutate({
                variables: { id: role.id, version: role.version },
                optimisticResponse: () => ({ deleteRole: { ...role, __typename: 'Role' } }),
            })
        }),
        options: {
            refetchQueries: [{ query: AllRolesQuery }],
            update: (proxy, { data: { deleteRole: { id, version } } }) => {
                const query = AllRolesQuery;
                const data = proxy.readQuery({ query });

                data.listRoles.items = data.listRoles.items.filter(role => role.id !== id && role !== version);

                proxy.writeQuery({ query, data });
            }
        }
    }),
    graphql(NewRoleMutation, {
        props: (props) => ({
            onAdd: role =>
                props.mutate({
                    variables: { ...role },
                    optimisticResponse: () => ({ createRole: { ...role, __typename: 'Role' } }),
                })
        }),
        options: {
            refetchQueries: [{ query: AllRolesQuery }],
            update: (dataProxy, { data: { createRole } }) => {
                const query = AllRolesQuery;
                const data = dataProxy.readQuery({ query });

                data.listRoles.items.push(createRole);
                dataProxy.writeQuery({ query, data });
            }
        }
    })
)(RoleIndexContainer);


// WEBPACK FOOTER //
// ./src/Components/Containers/Roles/Index.js